import { InitData } from '../../server/data/BaseModel';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { PresentationState } from '../../../dev/gameflow/controller/Presentation';
import { BonusIntroPresentation } from "../normal/BonusIntroPresentation";
import { RoadRage } from '../../RoadRage';
import { SplashController, SplashIndex } from '../../independent/splashScreen/SplashController';
import { FsLeftBox } from '../../background/FsLeftBox';
import { GameMode } from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';
import { RoadRageEngineManager } from '../../reel/RoadRageEngineManager';
import { stickyFS } from '../../server/data/IData';
import { PosterManager } from '../../independent/poster/PosterManager';

export class SetupRestoreIntro extends BonusIntroPresentation {

    private cartActivated:string[] = [];
    private activeValues:number[][] = [];

    private amount: number = 0;
    private isBelowStake: boolean = false;

    private initData: InitData;

    private isNormal: boolean = false;
    private startFromRight:boolean = false;

    private forceSize: boolean = false;

    private currentSize: number = 0;
    private ammS: number = 0;
    private stickyWilds: stickyFS[] = [];

    private switchLane:number[] = [];

    checkForActivation(data: InitData): boolean {
        return data.raw.isRestoreState && (data.mode === "FREESPIN_SETUP" || data.nextMode === "FREESPIN_SETUP");
    }

    // This badboy will define if it is a restore.
    setInitData(data: InitData): void {
        if (data.raw.isRestoreState && (data.mode === "FREESPIN_SETUP" || data.nextMode === "FREESPIN_SETUP")) {

            this.PresentationState.set(PresentationState.ACTIVATED);
            this.amount = data.Win.totalWin;

            this.isBelowStake = data.Win.isWinBelowStake!();
            super.setGamedData(data);
            this.initData = data;

            this.forceSize = data.nextModeSetup;
            this.currentSize = data.raw.fsInfo.fsGameSize ? data.raw.fsInfo.fsGameSize : 3;
            this.stickyWilds = data.Reel.stickWildPos;
            this.ammS = data.Reel.amountOfScattersLanded;

            this.isNormal = data.isNormalMode;
            this.switchLane = data.fsInfo.switchLane; 
            const carVal = data.fsInfo.isUTURN && data.fsRestoreData.carsBeforeUpdate ? data.fsRestoreData.carsBeforeUpdate : data.fsInfo.fsCars;
            const emptyVal = data.fsRestoreData.carsBeforeUpdate && !Object.keys(data.fsRestoreData.carsBeforeUpdate).length;
            this.startFromRight = data.Reel.isCarOnReel(4);
            if(!this.isNormal ){
                this.cartActivated = Object.keys(carVal);
                this.cartActivated.forEach(v => this.activeValues.push(emptyVal ? [1,1] : carVal[v]));
            }
        }
    }

    preStart(): void {
        SplashController.instance.setData(SplashIndex.INTRO, this.initData);
        RoadRageEngineManager.preferedLayoutSize = this.nextModePreferedSize;

        if(!this.isNormal){
            
            this.cartActivated.forEach((carKey,i) => {
                RoadRage.bgOverlay.enableBox(carKey,true,false);

                if(Object.keys(this.gameData.fsRestoreData.carsBeforeUpdate).find(v => v === carKey)){
                    RoadRage.bgOverlay.fetchBoxBytype(carKey).multValue = (this.gameData as InitData).fsRestoreData.carsBeforeUpdate[carKey][0];
                    RoadRage.bgOverlay.fetchBoxBytype(carKey).splitValue = (this.gameData as InitData).fsRestoreData.carsBeforeUpdate[carKey][1];
                }else{
                    RoadRage.bgOverlay.fetchBoxBytype(carKey).multValue = 1;
                    RoadRage.bgOverlay.fetchBoxBytype(carKey).splitValue = 1;
                }

            });
        }
      
        if(!this.forceSize){
            RoadRage.reelManager.forcedRestoreSizeChange(this.nextModePreferedSize);
            RoadRage.backgroundElements.forceBackground(this.nextModePreferedSize);
            RoadRageEngineManager.wantsToSwitch = false;
        }else{
            RoadRage.reelManager.forcedRestoreSizeChange(this.currentSize);
            RoadRage.backgroundElements.forceBackground(this.currentSize);
        }


        if( this.currentSize != this.ammS)
            PosterManager.instance.restoreShow(this.currentSize === 3, this.ammS === 4);

        FsLeftBox.instance.setAmount(this.gameData.raw.freespinsLeft - (this.gameData.fsInfo.addedNumberOfFreespinsThisSpin ? this.gameData.fsInfo.addedNumberOfFreespinsThisSpin : 0));
        SlotGame.keypadPlugin.setWin(this.amount, !this.isNormal, this.isBelowStake);

        if (Object.keys(this.initData.fsRestoreData).length){
            this.initData.fsRestoreData.previousEvaluatedArea.forEach((v, reel) => {
                this.gameData.Reel.constructionPositions[reel].forEach(cI => {
                    RoadRage.reelManager.AllReels[reel].getSymbol(cI)?.changeConstruction(v[cI], 0.1)
                })
            })
        }

        if(this.switchLane){
            RoadRageEngineManager.RSWindow((rc,sym) => {
                sym.setupMode(this.switchLane[rc.reelID], this.startFromRight)
                }
            )
        }

        RoadRageEngineManager.RSWindow((rc,sym) => {
            if(sym.symName === "F3"){
                sym.setupMode(0, !rc.reelID)
            }
        });

        if (this.gameData.mode === GameMode.NORMAL) {
            let amountofScatters = this.gameData.Reel.amountOfScatters;
            RoadRageEngineManager.RSWindow((rc, sym) => {
                if (sym.isScatter) {
                    sym.scatterState(amountofScatters + 1);
                }
            })
        }

        if (this.gameData.mode === GameMode.FREESPIN) {
            RoadRageEngineManager.RSWindow((rc, sym) => {
                if (sym.isCar) {
                    if(!this.stickyWilds.find(stW => stW.reel === rc.reelID && stW.row === sym.posID[0]))
                        sym.setSymbol("W");
                }
            })
        }

        if(this.stickyWilds.length)
            this.stickyWilds.forEach(v => {
                RoadRageEngineManager.getReel(v.reel).getSymbol(v.row)?.changeState({ state: "Wild", forceState: true, sym: v.type === "WC12" ? "WC4" : v.type, duration:0.15 })
                RoadRageEngineManager.getReel(v.reel).getSymbol(v.row)?.applyMultValue(v.multiplier);
                RoadRageEngineManager.getReel(v.reel).getSymbol(v.row)?.onSticky();
        })

        this.willAddFs = !!this.gameData.Reel.stickWildPos.length;
    }
}